<script>
import mapValues from 'lodash/mapValues'
import every from 'lodash/every'
import values from 'lodash/values'
import {
  deviceListComputed,
  deviceListMethods,
} from '@state/helpers/device-list'
import { requestUpload } from '@/src/services'
import { nameListComputed, nameListMethods } from '@state/helpers/name-list'
import SearchPayload from '@utils/searchPayload'
import { ObjectHelper, addParamsToLocation } from '@utils/helpers'
import cloneDeep from 'lodash/cloneDeep'
import tableFields from './tableFields'

export default {
  page: {
    title: 'Device List',
    meta: [{ name: 'description', content: 'The Device List page.' }],
  },
  data() {
    return {
      items: {},
      searchBody: new SearchPayload.Builder()
        .withSearchAgent()
        .withSearchMac()
        .withSearchDevicename(),
      fields: tableFields,
      filtered: false,
      openConfirm: false,
      openConfirmRegister: false,
      openConfirmEdit: false,
      openConfirmUpload: false,
      deviceIdSelected: {},
      switchId: null,
      deviceEdit: {
        agent_id: null,
        device_name: '',
        company: '',
      },
      deviceRegister: {
        agent_id: null,
        mac: '',
        device_name: '',
      },
      deviceSearch: {
        search_agent: '',
        search_mac: '',
        search_device_name: '',
        order_by: '',
      },
      showRegister: false,
      showSearch: false,
      registerDropdownkey: null,
      rules: { required: false, scope: { min: 0, max: 30 } },
      showEditModal: false,
      files: null,
      event: null,
      feedback: '',
      disabledUploadCSV: true,
      agentIdUpload: null,
    }
  },
  computed: {
    ...deviceListComputed,
    ...nameListComputed,
    deviceListData() {
      const list =
        cloneDeep(this.getDeviceList?.list)?.map((item) => {
          item.agent_id = item.id
          if (item.mesure_count === 0) {
            item.mesure_count = '-'
          }
          if (item.mesure_unique_member === 0) {
            item.mesure_unique_member = '-'
          }
          if (item.last_measure_time === '-') {
            item.last_measure_time = ''
          }
          return item
        }) || []
      return list
    },
    optionsSelectCompany() {
      const options = cloneDeep(this.getNameList?.list)?.map((item) => {
        return {
          value: item.id.toString(),
          label: item.company,
        }
      })
      return options
    },
    paginationComputed() {
      let paginations = {}
      if (this.getDeviceList) {
        paginations = ObjectHelper.removePropertyByKey('list')(
          this.getDeviceList
        )
      }
      return paginations
    },
    errorServerSideComputed() {
      return this.getRegisterErrors
    },
    unselectedAll() {
      return every(values(this.deviceIdSelected), function(v) {
        return !v
      })
    },
    loadingComputed() {
      return this.loading
    },
    confirmComputed() {
      if (this.unselectedAll) {
        return 'unselected'
      }
      return 'delete'
    },
  },
  watch: {
    searchBody() {
      addParamsToLocation(this.$route, this.searchBody)
    },
    showRegister() {
      this.registerDropdownkey = new Date().getTime()
      this.deviceRegister = mapValues(this.deviceRegister, () => '')
      this.deviceRegister.agent_id = this.optionsSelectCompany[0]?.value
    },
    getRegisterErrors() {
      this.$refs.register.setErrors(this.getRegisterErrors)
    },
    files() {
      if (this.files[0].type !== 'application/vnd.ms-excel') {
        this.feedback = 'This file not format CSV'
        this.disabledUploadCSV = true
      } else {
        this.feedback = ''
        this.disabledUploadCSV = false
      }
    },
  },
  created() {
    const filter = this.$route.query
    filter.page_no = parseInt(filter.page_no, 10)
    filter.lines = parseInt(filter.lines, 10)
    for (const key in filter) {
      if (filter[key] === 'undefined') {
        filter[key] = ''
      }
      if (key !== 'page_no' && key !== 'lines') {
        if (filter[key] !== '' && filter[key] !== undefined) {
          this.searchBody = filter
          this.filtered = true
        }
      }
    }
    if (filter.page_no > 1) {
      this.searchBody = filter
    }
    this.deviceSearch.search_agent = filter.search_agent
    this.deviceSearch.search_mac = filter.search_mac
    this.deviceSearch.search_device_name = filter.search_device_name

    this.handleSearchDevice()
    this.fetchingNameList()
  },
  methods: {
    ...deviceListMethods,
    ...nameListMethods,
    showModal() {
      this.openConfirm = !this.openConfirm
    },
    handlePagination(body) {
      this.searchBody = { ...this.searchBody, ...body }
      this.handleSearchDevice()
    },
    handleSorter(key) {
      this.searchBody = { ...this.searchBody, order_by: key }
      this.handleSearchDevice()
    },
    handleSearchDevice() {
      this.fetchingDeviceList(this.searchBody)
    },
    goToAddNewPage() {
      this.$router.push({ name: 'agentRegistration' })
    },
    handleSelected(id, value) {
      const temp = { ...this.deviceIdSelected }
      temp[id] = value
      this.deviceIdSelected = { ...temp }
    },
    searchDevice() {
      this.searchBody = { ...this.searchBody, ...this.deviceSearch }
      this.handleSearchDevice()
      this.filtered = true
      this.showSearch = false
    },
    async submitRegister() {
      const response = await this.registerDevice({
        agent_id: parseInt(this.deviceRegister.agent_id),
        device_name: this.deviceRegister.device_name,
        mac: this.deviceRegister.mac,
        model: '',
      })
      if (response) {
        this.showRegister = false
        this.handleSearchDevice()
        this.openConfirmRegister = false
      }
    },
    clearSearch() {
      const limit = this.searchBody.lines
      this.deviceSearch = mapValues(this.deviceSearch, () => '')
      this.searchBody = new SearchPayload.Builder()
        .withSearchAgent()
        .withSearchMac()
        .build()
      this.searchBody.lines = limit
      this.handleSearchDevice()
      this.filtered = false
      this.showSearch = false
    },
    async submitEdit() {
      const response = await this.editDeviceById({
        id: this.switchId,
        agent_id: parseInt(this.deviceEdit.agent_id),
        device_name: this.deviceEdit.device_name,
        model: '',
      })
      if (response) {
        this.openConfirmEdit = false
        this.showEditModal = false
        this.handleSearchDevice()
      }
    },
    goDetailPage(id, columnName, event) {
      if (columnName === 'edit') {
        return
      }
      this.$router.push({
        path: `/panel/device-list/${id}`,
      })
    },
    submit() {
      const temp = { ...this.deviceIdSelected }
      const flag = []
      for (const id in temp) {
        if (temp[id]) {
          flag.push(parseInt(id))
        }
      }
      Promise.all(
        flag?.map((id) => {
          return this.deleteDeviceById({ id })
        })
      ).then(() => {
        this.openConfirm = !this.openConfirm
        this.fetchingDeviceList(this.searchBody)
        this.deviceIdSelected = {}
      })
    },
    handleEditModal(item) {
      this.showEditModal = true
      this.switchId = item.device_id
      this.deviceEdit.agent_id = item.agent_id.toString()
      this.deviceEdit.device_name = item.device_name
      this.deviceEdit.company = item.company
    },
    async upload() {
      this.openConfirmUpload = false
      try {
        if (this.files[0]) {
          const formData = new FormData()
          if (!this.agentIdUpload) {
            this.agentIdUpload = parseInt(
              this.optionsSelectCompany[0].value,
              10
            )
          }
          formData.append('csv_file', this.files[0])
          formData.append('agent_id', parseInt(this.agentIdUpload, 10))
          const response = await requestUpload(
            '/cms/device/add_from_csv/',
            formData
          )
          if (response) {
            this.handleSearchDevice()
            this.disabledUploadCSV = true
            this.event.target.value = ''
            this.agentIdUpload = this.optionsSelectCompany[0].value
          }
        }
      } catch (err) {
        this.event.target.value = ''
        this.disabledUploadCSV = true
        this.agentIdUpload = this.optionsSelectCompany[0].value
      }
    },
    changeFiles(files, event) {
      this.files = files
      this.event = event
    },
  },
}
</script>

<template>
  <div>
    <BasePagination
      :paginations="paginationComputed"
      :searching="filtered"
      @activePagination="handlePagination"
    >
      <template v-slot:secondary>
        <CButtonGroup id="feeline-group-btn">
          <CDropdown
            :show.sync="showRegister"
            placement="bottom-start"
            toggler-text="新規登録"
            add-toggler-classes="btn btn-outline-dark feeline-border-right"
            add-menu-classes="p-2"
          >
            <validation-observer ref="register" v-slot="{ handleSubmit }">
              <CForm
                :key="registerDropdownkey"
                @submit.stop.prevent="
                  handleSubmit(() => {
                    openConfirmRegister = true
                  })
                "
              >
                <BaseSelect
                  label="アライアンス名"
                  placeholder=""
                  :options="optionsSelectCompany"
                  :value.sync="deviceRegister.agent_id"
                />
                <BaseInput
                  v-model="deviceRegister.mac"
                  label="Macアドレス"
                  name="macAddress"
                  vee-name="macAddress"
                  :rules="{ requiredWithFormat: true, mac: true }"
                />
                <BaseInput
                  v-model="deviceRegister.device_name"
                  label="デバイス名"
                  :rules="{ required: true, max: 16 }"
                />
                <CButton
                  color="dark"
                  variant="outline"
                  class="w-100"
                  type="submit"
                >
                  登録
                </CButton>
              </CForm>
            </validation-observer>
          </CDropdown>
          <CDropdown
            placement="bottom-start"
            toggler-text="CSV一括登録"
            add-toggler-classes="btn btn-outline-dark rounded-0 border-left-0"
            add-menu-classes="p-2"
          >
            <template>
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <CForm
                  ref="form"
                  @submit.stop.prevent="
                    handleSubmit(() => {
                      openConfirmUpload = true
                    })
                  "
                >
                  <BaseSelect
                    label="アライアンス名"
                    :options="optionsSelectCompany"
                    :value.sync="agentIdUpload"
                  />
                  <CInputFile
                    :invalid-feedback="feedback"
                    accept=".csv"
                    placeholder="Browse"
                    @change="(files, event) => changeFiles(files, event)"
                  >
                    <template v-slot:invalid-feedback>
                      <div class="invalid-csv">{{ feedback }}</div>
                    </template>
                  </CInputFile>
                  <CButton
                    color="primary"
                    type="submit"
                    class="w-100"
                    :disabled="disabledUploadCSV"
                  >
                    アップロード
                  </CButton>
                </CForm>
              </validation-observer>
            </template>
          </CDropdown>
          <CButton color="dark" variant="outline" @click="showModal"
            >削除</CButton
          >
          <CDropdown
            :show.sync="showSearch"
            placement="bottom-end"
            add-toggler-classes="btn btn-outline-dark feeline-border-left border-left-0"
            add-menu-classes="p-2"
          >
            <template v-slot:toggler-content>
              <font-awesome-icon icon="search" />
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <CForm
                ref="form"
                @submit.stop.prevent="handleSubmit(searchDevice)"
              >
                <BaseInput
                  v-model="deviceSearch.search_agent"
                  label="アライアンス名"
                  :rules="rules"
                />
                <BaseInput
                  v-model="deviceSearch.search_mac"
                  label="Macアドレス"
                />
                <BaseInput
                  v-model="deviceSearch.search_device_name"
                  label="デバイス名"
                />
                <div class="d-flex">
                  <CButton color="primary" type="submit" class="w-50">
                    検索
                  </CButton>
                  <CButton color="light" class="ml-2 w-50" @click="clearSearch">
                    クリア
                  </CButton>
                </div>
              </CForm>
            </validation-observer>
          </CDropdown>
        </CButtonGroup>
      </template>
    </BasePagination>
    <BaseTable
      striped
      border
      hover
      :loading="loadingComputed"
      :table-fields="fields"
      :data-tables="deviceListData"
      @sorterBy="handleSorter"
      @row-clicked="
        (item, index, columnName, event) =>
          goDetailPage(item.device_id, columnName, event)
      "
    >
      <template v-slot:checkbox="{ item }">
        <td class="py-2" @click.stop="() => {}">
          <CInputCheckbox
            :checked="deviceIdSelected[item.device_id]"
            color="primary"
            @update:checked="(v) => handleSelected(item.device_id, v)"
          />
        </td>
      </template>
      <template v-slot:mac="{ item }">
        <td>
          {{ item.mac }}
        </td>
      </template>
      <template v-slot:edit="{ item }">
        <td>
          <CButton
            variant="outline"
            color="danger"
            @click="handleEditModal(item)"
          >
            <simple-line-icons icon="pencil" no-svg />
          </CButton>
        </td>
      </template>
    </BaseTable>
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirm"
      :type="confirmComputed"
      :hide-action-button="unselectedAll"
      @closeModal="openConfirm = !openConfirm"
      @submit="submit"
    />
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirmRegister"
      type="add"
      @closeModal="openConfirmRegister = !openConfirmRegister"
      @submit="submitRegister"
    />
    <BaseFormModal
      :show-modal="showEditModal"
      @close="showEditModal = false"
      @submit="openConfirmEdit = true"
    >
      <template v-slot:form>
        <BaseSelect
          :placeholder="deviceEdit.company"
          :options="optionsSelectCompany"
          :value.sync="deviceEdit.agent_id"
        />
        <BaseInput
          v-model="deviceEdit.device_name"
          :rules="{ required: true, max: 16 }"
        />
      </template>
    </BaseFormModal>
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirmEdit"
      type="edit"
      @closeModal="openConfirmEdit = !openConfirmEdit"
      @submit="submitEdit"
    />
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirmUpload"
      type="add"
      @closeModal="openConfirmUpload = !openConfirmUpload"
      @submit="upload"
    />
  </div>
</template>

<style lang="scss" scoped>
::v-deep .feeline-border-right {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

::v-deep .feeline-border-left {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

#feeline-group-btn {
  ::v-deep .dropdown-menu {
    min-width: 12rem;
  }
}
</style>
